<template>
  <!--  </TabPanel>-->
  <Accordion :activeIndex="0">
    <AccordionTab header="Thống kê CheckIn/CheckOut theo tháng">
<!--      <div class="p-fluid p-formgrid p-grid">-->
        <Panel>
<!--          <div class="p-fluid">-->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-3">
                <!--          <label>Chọn khoản thời gian thống kê: </label>-->
                <Calendar
                    id="dateMonth"
                    v-model="dateMonth"
                    selectionMode="single"
                    view="month" dateFormat="mm/yy"
                    :showButtonBar="true"
                    :showIcon="true"
                    :manualInput="false"
                    :monthNavigator="true"
                    :yearNavigator="true"
                    yearRange="2000:2100"
                    @date-select="selectCalendar()"
                    @clear-click="clearCalendar()"
                />
              </div>
              <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
                <Dropdown v-model="idDepartment" :options="listDepartment" optionLabel="name" optionValue="id" placeholder="Chọn khoa/ phòng" :filter="true">
                </Dropdown>
              </div>
              <div class="p-field p-col p-col-12 p-md-2 p-lg-2">
                <Button label="Xử lý" icon="pi pi-spinner" iconPos="left" @click="exportFileMonth()" :disabled="dateMonth"/>
              </div>
              <div class="p-field p-col p-col-12 p-md-3 p-lg-2">
                <Button label="Tải danh sách" icon="pi pi-download" iconPos="left" @click="downLoadFileExport(fileNameMonth, 1)" :disabled="!downloadFile"/>
              </div>
<!--              <div class="p-field p-col-12 p-sm-12 p-md-12">-->
<!--                <Dialog header="Đang xử lý" v-model:visible="loadingData" >-->
<!--                  <div id="loadingExportMonth">-->
<!--                    <label>Đang tải dữ liệu, vui lòng chờ...</label>-->
<!--                    <ProgressBar mode="indeterminate" style="height: .3em" />-->
<!--                  </div>-->
<!--                </Dialog>-->
<!--                <ConfirmDialog></ConfirmDialog>-->
<!--              </div>-->
            </div>
<!--          </div>-->
        </Panel>
<!--      </div>-->
    </AccordionTab>
    <AccordionTab header="Thống kê CheckIn/CheckOut chi tiết theo ngày">
      <div class="p-fluid p-formgrid p-grid">
<!--       <Panel >-->
<!--          <div class="p-fluid">-->
<!--      <div class="p-fluid p-formgrid p-grid">-->
        <div class="p-field p-col-12 p-md-4">
<!--          <label>Chọn khoản thời gian thống kê: </label>-->
          <Calendar
              id="date"
              v-model="date"
              selectionMode="single"
              dateFormat="dd/mm/yy"
              :showButtonBar="true"
              :showIcon="true"
              :manualInput="false"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2100"
              @date-select="selectCalendar()"
              @clear-click="clearCalendar()"
          />
        </div>
        <div class="p-field p-col p-col-12 p-md-2 p-lg-2">
          <Button label="Xử lý" icon="pi pi-spinner" iconPos="left" @click="exportFile()" :disabled="listThongKeDiemDanh.length < 1"/>
        </div>
        <div class="p-field p-col p-col-12 p-md-3 p-lg-2">
          <Button label="Tải danh sách" icon="pi pi-download" iconPos="left" @click="downLoadFileExport(fileName, 0)" :disabled="!downloadFile"/>
        </div>
        <div class="p-field p-col-12 p-md-12">
      <DataTable
              :value="listThongKeDiemDanh" :paginator="true" stripedRows
              :rows="10" :rowsPerPageOptions="[10,50,150]" :rowHover="true"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :globalFilterFields="['fullName','phoneNumber','team']" showGridlines
              currentPageReportTemplate="Có tất cả {totalRecords} dữ liệu"
              v-model:filters="filters" style="font-size: 13px">
        <template #header>
          <div class="p-d-flex p-jc-between p-ai-center">
            <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
            <span class="p-input-icon-left" style="width: 18em">
                    <i class="pi pi-search" />
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo tên hoặc số điện thoại" />
                  </span>
          </div>
        </template>
        <Column field="fullName" header="Họ và tên" sortable style="font-weight: bolder"></Column>
        <Column field="phoneNumber" header="Số điện thoại" sortable></Column>
        <Column field="team" header="Khoa/ Phòng" style="font-weight: bolder" sortable></Column>
        <Column field="checkInMorning" header="Checkin sáng" sortable style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkInMorningImage">
              <template #title> Checkin sáng </template>
              <template #content>
                <Image :src="data.checkInMorningImage" :alt="data.checkInMorningImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkInMorning)" severity="success" />
              </template>
            </Card>
            <div v-else>
              <Tag value="Không có dữ liệu" severity="danger" />
            </div>
          </template>
        </Column>
        <Column field="checkInMorningLatest" dataType="date" header="Checkin sáng đi trễ" sortable style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkInMorningLatestImage">
              <template #title> Checkin sáng đi trễ</template>
              <template #content>
                <Image :src="data.checkInMorningLatestImage" :alt="data.checkInMorningLatestImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkInMorningLatest)" severity="danger" />
              </template>
            </Card>
          </template>
        </Column>
        <Column field="checkOutMorning" dataType="date" header="Checkout sáng" sortable  style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkOutMorningImage">
              <template #title> Checkout sáng</template>
              <template #content>
                <Image :src="data.checkOutMorningImage" :alt="data.checkOutMorningImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkOutMorning)" severity="warning" />
              </template>
            </Card>
            <div v-else>
              <Tag value="Không có dữ liệu" severity="danger" />
            </div>
          </template>
        </Column>
        <Column field="checkInAfternoon" dataType="date" header="Checkin chiều" sortable  style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkInAfternoonImage">
              <template #title> Checkin chiều</template>
              <template #content>
                <Image :src="data.checkInAfternoonImage" :alt="data.checkInAfternoonImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkInAfternoon)" severity="success" />
              </template>
            </Card>
            <div v-else>
              <Tag value="Không có dữ liệu" severity="danger" />
            </div>
          </template>
        </Column>
        <Column field="checkInAfternoonLatest" dataType="date" header="Checkin chiều đi trễ" sortable  style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkInAfternoonLatestImage">
              <template #title> Checkin chiều đi trễ</template>
              <template #content>
                <Image :src="data.checkInAfternoonLatestImage" :alt="data.checkInAfternoonLatestImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkInAfternoonLatest)" severity="danger" />
              </template>
            </Card>
          </template>
        </Column>
        <Column field="checkOutAfternoon" dataType="date" header="Checkout chiều" sortable  style="width: 150px">
          <template #body="{data}">
            <Card v-if="data.checkOutAfternoonImage">
              <template #title> Checkout chiều</template>
              <template #content>
                <Image :src="data.checkOutAfternoonImage" :alt="data.checkOutAfternoonImage" width="150" preview/>
              </template>
              <template #footer>
                <Tag :value="formatDateTime(data.checkOutAfternoon)" severity="warning" />
              </template>
            </Card>
            <div v-else>
              <Tag value="Không có dữ liệu" severity="danger" />
            </div>
          </template>
        </Column>
        <ColumnGroup type="footer">
          <Row>
            <Column footer="Tổng cộng:" :colspan="3" footerStyle="text-align:right"/>
            <Column :footer="checkInMorningCount"/>
            <Column footer=""/>
            <Column :footer="checkOutMorningCount"/>
            <Column :footer="checkInAfternoonCount"/>
            <Column footer=""/>
            <Column :footer="checkOutAfternoonCount"/>
          </Row>
        </ColumnGroup>
        <template #empty style="font-size: 13px">
          Không có thông tin CheckIn/CheckOut.
        </template>
      </DataTable>
        </div>
        <div class="p-field p-col-12 p-sm-12 p-md-12">
          <Dialog header="Đang xử lý" v-model:visible="loadingData" >
            <div id="loadingExport">
              <label>Đang tải dữ liệu, vui lòng chờ...</label>
              <ProgressBar mode="indeterminate" style="height: .3em" />
            </div>
          </Dialog>
          <ConfirmDialog></ConfirmDialog>
<!--        </div>-->
<!--      </div>-->
    </div>
<!--    </div>-->
<!--        </Panel>-->
      </div>
    </AccordionTab>
  </Accordion>
</template>

<script lang="ts">

  import { computed, ref } from 'vue'
  import moment from 'moment';
  import {FilterMatchMode, FilterOperator} from "primevue/api";
  import router from "@/router";
  import {useToast} from "primevue/usetoast";
  import {useStore} from "vuex";
  import {RegisterService} from "@/models/registerService";
  import ZaloRepository from "@/services/ZaloRepository";
  import {ListService} from "@/models/listService";
  import {useRouter} from "vue-router";
  import {NghiPhepDetail} from "@/models/nghiPhepDetail";
  import zaloRepository from "@/services/ZaloRepository";
  import {ThongKeDiemDanh} from "@/models/thongKeDiemDanh";
  import axios from "axios";
  import {Department} from "@/models/department";

  export default {
    setup() {
      const toast = useToast();
      const store = useStore();
      const date = ref();
      const dateMonth = ref();
      const service = ref("");
      const router = useRouter();
      const kind = ref(0);
      const listThongKeDiemDanh = ref([] as ThongKeDiemDanh[]);
      const loadingData = ref(false);
      const listDepartment =  ref([] as Department[]);
      const idDepartment = ref(0);

      const getListDepartments = () => {
          zaloRepository.getListDepartments()
              .then((response) => {
                listDepartment.value = response.data;
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })})
      };
      getListDepartments();

      const selectCalendar = () => {
        loadingData.value = false;
        if((date.value != null))
        {
          loadingData.value = true;
          listThongKeDiemDanh.value = [];
          downloadFile.value = false;
          zaloRepository.getListThongKeDiemDanh(date.value/1000)
              .then((response) => {
                listThongKeDiemDanh.value = response.data;
                loadingData.value = false;
                console.log("@@@@@@@@@################ list: " + JSON.stringify(listThongKeDiemDanh.value));
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })})
        }
      };

      //selectCalendar();

      const clearCalendar = () => {
        listThongKeDiemDanh.value = [];
      }

      const formatDateTime = (date) => {
        if((date == null)||(date == ''))
        {
          return "chưa có thông tin"
        }
        else
        return moment(String(date)).format('HH:mm DD/MM/YYYY');
      };


      const validDate = (registerService: RegisterService) => {
        return registerService.timeConfirm;
      }

      const clearDate = () => {
        console.log("@@@@@@@@@################ clearDate");
        date.value = new Date();
      }

      const status = (id, xn) => {
        if(xn) return "Cho phép nghỉ";
        else {
          if(id > 0) return "Không cho phép nghỉ";
          else return "Chưa xác nhận";
        }
      }
      const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
      });

      const clearFilter = () => {
        initFilters();
      };

      const initFilters = () => {
        filters.value = {
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        }
      };

      const checkInMorningCount = computed(() => {
        var id = 0;
        listThongKeDiemDanh.value.forEach(x => {
          if(x.checkInMorningImage != null)
          {
            console.log("@@@@@@@@@################ null: ");
            id = id + 1;
          }
        })
        console.log("@@@@@@@@@################ id: " + id);
        return "Checkin buổi sáng: " + id;
      })

      const checkOutMorningCount = computed(() => {
        var id = 0;
        listThongKeDiemDanh.value.forEach(x => {
          if(x.checkOutMorningImage != null)
          {
            console.log("@@@@@@@@@################ null: ");
            id = id + 1;
          }
        })
        console.log("@@@@@@@@@################ id: " + id);
        return "Checkout buổi sáng: " + id;
      })

      const checkInAfternoonCount = computed(() => {
        var id = 0;
        listThongKeDiemDanh.value.forEach(x => {
          if(x.checkInAfternoonImage != null)
          {
            console.log("@@@@@@@@@################ null: ");
            id = id + 1;
          }
        })
        console.log("@@@@@@@@@################ id: " + id);
        return "Checkin buổi chiều: " + id;
      })

      const checkOutAfternoonCount = computed(() => {
        var id = 0;
        listThongKeDiemDanh.value.forEach(x => {
          if(x.checkOutAfternoonImage != null)
          {
            console.log("@@@@@@@@@################ null: ");
            id = id + 1;
          }
        })
        console.log("@@@@@@@@@################ id: " + id);
        return "Checkout buổi chiều: " + id;
      })

      const downloadFile = ref(false);
      const loadingBar = ref(false);
      const fileName = ref("");
      const loadingExport = ref(false);
      const exportFile = () => {
        loadingExport.value = true;
        downloadFile.value = false;
        zaloRepository.exportListCheckIn(listThongKeDiemDanh.value)
            .then((response) => {
              fileName.value = response.data;
              toast.add({
                severity: 'success',
                summary: 'Xuất dữ liệu',
                detail: 'Xuất dữ liệu thành công',
                life: 2000
              });
              loadingExport.value = false;
              downloadFile.value = true;
              // router.push({
              //   name: 'home'
              // });
            })
            .catch(err => {
              loadingBar.value = false;
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2000
              });
            });
      }

      const downLoadFileExport = (file, kind) => {
        axios({
          url: '../api/webhook/downloadListCheckIn/' + file,
          method: 'GET',
          responseType: 'blob',
        })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
              const link = document.createElement('a');
              link.href = url;
              if(kind == 0) {
                link.setAttribute('download', "DanhSachCheckIn" + "(" + moment(String(date.value)).format('DD/MM/YYYY') + ")" + ".xlsx");
              }
              else{
                link.setAttribute('download', "DanhSachCheckInThang" + "(" + moment(String(dateMonth.value)).format('MM/YYYY') + ")" + ".xlsx");
              }
              document.body.appendChild(link);
              link.click();
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      };
      const fileNameMonth = ref("");

      const exportFileMonth = () => {
        loadingExport.value = true;
        downloadFile.value = false;
        if((dateMonth.value != null)) {
          loadingData.value = true;
          zaloRepository.getListThongKeDiemDanhMonth(dateMonth.value / 1000, idDepartment.value)
              .then((response) => {
                fileNameMonth.value = response.data;
                toast.add({
                  severity: 'success',
                  summary: 'Xuất dữ liệu',
                  detail: 'Xuất dữ liệu thành công',
                  life: 2000
                });
                loadingExport.value = false;
                downloadFile.value = true;
                loadingData.value = false;
                // router.push({
                //   name: 'home'
                // });
              })
              .catch(err => {
                loadingBar.value = false;
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail: err.response.data,
                  life: 2000
                });
              });
        }
      }

      return {
        formatDateTime,
        listThongKeDiemDanh,
        date,
        selectCalendar,
        clearCalendar,
        service,
        validDate,
        kind,
        clearDate,
        status,
        clearFilter,
        filters,
        checkInMorningCount,
        checkOutMorningCount,
        checkInAfternoonCount,
        checkOutAfternoonCount,
        exportFile,
        downLoadFileExport,
        loadingExport,
        downloadFile,
        loadingData,
        dateMonth,
        exportFileMonth,
        fileName,
        fileNameMonth,
        idDepartment,
        listDepartment,
      }
    }

  }
</script>
<style lang="scss">
.p-card .p-card-title{
  font-size: 14px;
  margin-bottom: 0;
  text-align: center;
}
.p-card .p-card-footer {
  padding: 0 0 0 0;
}
.p-card .p-card-content {
  padding: 0 0;
}
.p-panel .p-panel-header .p-panel-title{
  font-size: 13px;
}
label , .p-inputtext, .p-button-label, .p-paginator-current {
  font-size: 13px;
}
</style>